<section class="search-wrapper">
  <!--ALREADY HAVE AN USER ACCOUNT-->
  <!--NOTE: only show login shortcut banner if user is NOT logged in-->
  <app-login-shortcut-banner [user]="!currentUser"></app-login-shortcut-banner>
  <!--END ALREADY HAVE AN USER ACCOUNT-->
  <!--FULL CATALOG HERO BANNER-->
  <div class="sub-hero training-for-all-cx-roles-hero">
    <div class="wrapper">
      <div class="toggle-nav-container">
        <!--HERO HEADING-->
        <h1 class="brand margin-bottom-large">Find the right training for you.</h1>
      </div>
      <!--TOGGLE HERO TEXT IF FULL CATALOG-->
      <div class="sub-hero-wrapper">
        <!--FULL CATALOG CONTENT-->
        <!--NOTE: The content below is reacting to the emitted toggle state in the toggle navigation-->
        <ng-container *ngIf="isShowFullCatalog; else showELearningContent">
          <h2 class="text-align-left">Full Catalog</h2>
          <p class="medium margin-top-large">
            Browse through an extensive catalog of virtual instructor-led and self-paced courses for
            each Genesys product. Find courses that are unique to your role, including training for
            business users, system administrators, and developers. Choose the course type that suits
            your needs and then select the date and time that best fits your schedule.
          </p>
        </ng-container>
        <!--ELEARNING HERO CONTENT-->
        <ng-template #showELearningContent>
          <h2 class="text-align-left">eLearning Library</h2>
          <p class="medium margin-top-large">
            eLearning content consists of self-paced modules designed to deliver pre-deployment,
            just-in-time, post-deployment, and reference training. Modules range anywhere from five
            to twenty-five minutes in length and feature a mix of text-based and video material.
            With eLearning content, you don’t need to plan your training around our public training
            schedule. Instead, you control when training starts and when breaks are needed. If more
            time is needed on a specific topic, you can always revisit a section to make sure you
            completely understand each module.
          </p>
        </ng-template>
        <!--END ELEARNING HERO CONTENT-->
      </div>
    </div>
  </div>
  <!--END FULL CATALOG HERO BANNER-->
  <div class="wrapper" id="contentWrapper">
    <div class="columns">
      <!--CATALOG FILTER ASIDE-->
      <div
        class="catalog-column"
        [ngClass]="{ 'show-mobile-mode': toggleFilter, 'mobile-filter-height': !currentUser }">
        <div class="toggle-filter margin-bottom-small">
          <h3 class="bold margin-bottom-small">Filter by:</h3>
          <!--FILTER ACCORDION ICON-->
          <!--<i class="icon red filtering small" [ngClass]="{ 'show-mobile-mode': toggleFilter }" (click)="onToggleFilter()"></i>-->
          <!--END FILTER ACCORDION ICON-->
        </div>
        <!--ACCORDION-->
        <div>
          <app-accordion
            #searchCatalogAccordion
            [entries]="filterCatalogItemsAccordionData"
            [fragment]="fragment"
            (toggle)="selectedItems($event)">
          </app-accordion>
        </div>
        <!--END ACCORDION-->
        <!--TODO: Move buttons to accordion component-->
        <div class="btn-apply margin-top-small">
          <!--APPLY FILTERS BUTTON-->
          <div class="btn-applyfilters">
            <button
              id="apply-seach-filters"
              [attr.data-beyond-button-id]="'apply-seach-filters'"
              [disabled]="disableApplyButton"
              class="btn btn-primary margin-right-small"
              (click)="applyFilters()">
              Apply Filters
            </button>
          </div>
          <!--RESET FILTERS BUTTON-->
          <div class="btn-reset">
            <button
              id="reset-filters"
              [attr.data-beyond-button-id]="'reset-filters'"
              class="btn btn-inverse"
              (click)="resetFields()">
              Reset
            </button>
          </div>
        </div>
      </div>
      <!--END CATALOG FILTER ASIDE-->
      <div class="aside-column">
        <!--SEARCH FILTER-->
        <div class="search-filter-new">
          <!--TOGGLE FILTER ICON-->
          <i
            [ngClass]="toggleFilter === true ? 'black' : 'red'"
            class="icon filtering small margin-right-small show-filter cursor"
            (click)="onToggleFilter()"></i>
          <!--END TOGGLE FILTER ICON-->
          <!--SEARCH INPUT-->
          <app-search-input
            [searchPlaceholderMessage]="'Search catalog'"
            [hideSearchBlock]="false"
            (sendSearchQuery)="onCatalogSearch($event)"
            (inputValueChange)="onChangeQuery($event)"
            [searchQueryData]="query"></app-search-input>
          <!--END SEARCH INPUT-->
        </div>
        <!--END SEARCH FILTER-->
        <!--NO SEARCH RESULTS FOUND MESSAGE-->
        <ng-template [ngIf]="!isLoading && results.length === 0">
          <p class="medium inactive margin-top-large text-align-center">
            No search results found
            <span *ngIf="query && query.length > 0"> for "{{ getQuery(query) }}"</span>
            . Please try a different query.
          </p>
        </ng-template>
        <!--END NO SEARCH RESULTS FOUND MESSAGE-->
        <!--COURSE CATALOG SEARCH RESULTS COUNT AND SORT OPTION-->
        <div
          class="results-container margin-top-large"
          *ngIf="!isLoading && results && results.length > 0">
          <!--CURRENT TOTAL PAGE STATUS-->
          <span class="results-header margin-top-small margin-bottom-small">
            <span>
              Showing page {{ currentPage }} of {{ totalPages(results.length) }} with
              {{ results.length }} total result<span *ngIf="results.length !== 1">s</span>
              <span class="bold" *ngIf="query !== ''">
                for "{{ getQuery(query) }}"<span *ngIf="query.length > charLimit"> &hellip; </span>
              </span>
            </span>
          </span>
          <!--END CURRENT TOTAL PAGE STATUS-->
          <!--SORT OPTIONS-->
          <div class="sort-outer-container">
            <div class="margin-top-small margin-bottom-small">
              <span class="sort-toggle cursor" (click)="sortByName()">
                Sort {{ isSortAscending ? 'Descending' : 'Ascending' }}
                <i
                  class="icon red x-small"
                  [ngClass]="isSortAscending ? 'arrow-up' : 'arrow-down'"></i>
              </span>
            </div>
          </div>
          <!--END SORT OPTIONS-->
        </div>
        <!--END COURSE CATALOG SEARCH RESULTS COUNT AND SORT OPTION-->
        <!--COURSE CATALOG SEARCH RESULTS-->
        <div class="search-results">
          <ng-container *ngIf="isLoading">
            <app-loading-spinner></app-loading-spinner>
          </ng-container>

          <ng-container *ngIf="!isLoading">
            <div class="tile-layout-3 margin-bottom-large">
              <ng-template [ngIf]="results && results.length > 0">
                <ng-container
                  *ngFor="
                    let result of results
                      | paginate : { itemsPerPage: itemsPerPage, currentPage: currentPage };
                    let i = index;
                    trackBy: trackByResultId
                  ">
                  <!--COURSE CARD-->
                  <ng-template [ngIf]="result.type !== learningType.SUBSCRIPTION">
                    <app-card
                      [id]="result.id"
                      [cardType]="result.instructionType | cardType"
                      [cardSubType]="result.instructionType | cardSubType"
                      [instructionType]="result.instructionType"
                      [queryParams]="getCourseQuery(result.id, result.slug)"
                      [title]="result.name"
                      [showSubTitle]="
                        result.instructionType | showCardSubHeaderTitle : result.isFreeCourse
                      "
                      [courseDuration]="
                        result.instructionType
                          | formatDuration : result.courseDuration : result.courseDurationMins
                      "
                      [routeType]="
                        result.instructionType
                          | cardTypeCallToActions
                            : currentUser
                            : result.parentId
                            : result.parentSubscriptionIds
                            : result.id
                            : result.isFreeCourse
                            : result.relatedCourseIds
                            : 'search'
                          | routeTypesByCallToActions : result.instructionType : true
                      "
                      secondaryLinkRoute="{{ 'subscription/' + result.parentSlug }}"
                      route="{{ 'course/' + result.id }}"
                      [buttonRoute]="
                        currentUser
                          | courseTypeRoute
                            : result.instructionType
                            : result.slug
                            : result.parentId
                            : result.id
                            : 'search'
                      "
                      (sendClick)="
                        sendGoogleAnalytics('Catalog', 'click', result.slug);
                        loadEnrollELearning($event, result.instructionType, result.id);
                        loadEnrollCertification(
                          $event,
                          result.instructionType,
                          result.id,
                          result.name
                        )
                      "
                      [icon]="['info-icon', 'small', 'white']"
                      [customHeaderCss]="result.instructionType | instructionTypeCustomHeader"
                      [customCardHeightCss]="'card-max-height'"
                      [customHeadingGroupCss]="'card-heading-group'"
                      [customButtonCss]="result.instructionType | instructionTypeCustomButton"
                      [description]="result.description"
                      [informationTooltip]="
                        (result.parentSubscriptionIds && result.parentSubscriptionIds.length > 0
                          ? result.parentSubscriptionIds
                          : [result.parentId]
                        ) | courseSubscriptionTooltip : result.instructionType
                      "
                      [showTooltip]="true"
                      actionLabel="{{
                        result.instructionType
                          | cardTypeCallToActions
                            : currentUser
                            : result.parentId
                            : result.parentSubscriptionIds
                            : result.id
                            : result.isFreeCourse
                            : result.relatedCourseIds
                            : 'search'
                      }}">
                    </app-card>
                  </ng-template>
                  <!--END COURSE CARD-->
                </ng-container>
              </ng-template>
            </div>
          </ng-container>
          <!--PAGING CONTROLS-->
          <ng-template [ngIf]="!isLoading && results && results.length > 0">
            <pagination-controls
              (pageChange)="pageChanged($event)"
              maxSize="9"
              class="search-pagination">
            </pagination-controls>
          </ng-template>
          <!--END PAGING CONTROLS-->
        </div>
        <!--END COURSE CATALOG SEARCH RESULTS-->
      </div>
    </div>
  </div>
</section>

<!--REQUEST A QUOTE (VOUCHER) FORM-->
<app-modal-dialog [containerID]="'requestForm'" [modalMaxWidth]="'modal-max-width-medium'">
  <div #modalContainer>
    <app-request-form [formHeading]="'Request a Quote'"></app-request-form>
  </div>
</app-modal-dialog>
<!--END REQUEST A QUOTE (VOUCHER) FORM-->
